export const validationSchema = {
    email: {
        required: 'Email is required',
        pattern: {
            regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: 'Please enter a valid email address'
        }
    },
    password: {
        required: "Password is required",
        match: "Password do not match.",
        pattern: {
            regex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            message: 'Password must be at least 8 characters long, include uppercase and lowercase letters, a number, and a special character'
        }
    }
}